import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=2c6ed54a&scoped=true"
import script from "./SelectGoods.vue?vue&type=script&lang=js"
export * from "./SelectGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectGoods.vue?vue&type=style&index=0&id=2c6ed54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ed54a",
  null
  
)

export default component.exports